module.exports = __webpack_public_path__ + "img/al.3434b615.png";